import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { JiffyProjectSection } from "../../containers/projects";

const JiffyProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Jiffy - Projects"
        description="Frontend work on Jiffy Shirts | E-commerce | Typescript, Vue, Rails"
      />
      <JiffyProjectSection />
    </Layout>
  );
};

export default JiffyProjectPage;
